import { render, staticRenderFns } from "./FileUploadAndDispatch.vue?vue&type=template&id=3015c401&scoped=true&"
import script from "./FileUploadAndDispatch.vue?vue&type=script&lang=js&"
export * from "./FileUploadAndDispatch.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadAndDispatch.vue?vue&type=style&index=0&id=3015c401&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015c401",
  null
  
)

export default component.exports